const row = "flex items-center justify-between px-3 py-2 text-sm border-b border-border last:border-b-0";

const flexCenter = "flex items-center gap-3 shrink-0";

const statusTimeText = "text-xs text-muted-foreground flex items-center gap-1";

const divider = "border-b border-border";

const fontMonoBold = "font-mono font-semibold";

const fontMonoWithMr3 = "font-mono mr-3";

const successIcon = "h-4 w-4 text-success shrink-0";

const successIconSmall = "h-3 w-3 text-success shrink-0";

const errorIcon = "h-4 w-4 text-destructive shrink-0";

const errorIconSmall = "h-3 w-3 text-destructive shrink-0";

const statusBadge = "px-2 py-0.5 text-xs font-medium rounded-full bg-success/10 text-success";

const resultsContainer = "rounded-md border border-border shrink-0";

const resultsDivider = "mx-1 text-muted-foreground";

export {
  row,
  flexCenter,
  statusTimeText,
  divider,
  fontMonoBold,
  fontMonoWithMr3,
  successIcon,
  successIconSmall,
  errorIcon,
  errorIconSmall,
  statusBadge,
  resultsContainer,
  resultsDivider,
};
